import { render, staticRenderFns } from "./ToolSettingsPerimeter.vue?vue&type=template&id=048fa1ca&scoped=true&"
import script from "./ToolSettingsPerimeter.vue?vue&type=script&lang=js&"
export * from "./ToolSettingsPerimeter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048fa1ca",
  null
  
)

export default component.exports